export const environment = {
  production: true,
  msalConfig: {
    auth: {
      clientId: '9746e63b-820a-4cd8-aee1-8de90f61098e',
      authority:
        'https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  backendConfig: {
    url: 'https://gt-fox-stage-zco25zclta-uc.a.run.app',
    storage_cdn: 'https://pixelprobe-storage.hashedin.com',
  },
};
